module.exports = __webpack_public_path__ + "img/img4_5.b2e1e7a3.jpeg";